import {useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Colors, FlexBox} from "@brg/ui";
import styled from "styled-components";
import {IPhoneSwitcher} from "./IPhoneSwitcher";

const Label = styled.span`
  color: ${Colors.galBlack47};
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`

export const CopyLinkSwitcher = () => {
    const [active, setActive] = useState(
        localStorage.getItem('copyLinkMode') === 'true'
    )
    const [visible, setIsVisible] = useState(
        localStorage.getItem('copyLinkMode') === 'true'
    )
    const { t } = useTranslation()

    // @ts-ignore
    const onSetActive = useCallback((value) => {
        localStorage.setItem('copyLinkMode', value ? 'true' : 'false')
        setActive(value)
    }, [])

    useEffect(() => {
        const onSetStorage = (e: any) => {
            if (e.key === 'copyLinkMode') {
                setActive(e.newValue === 'true')
                if (e.newValue === 'true') setIsVisible(true)
            }
        }

        window.addEventListener('storage', onSetStorage)

        return () => {
            localStorage.setItem('copyLinkMode', 'false')
            window.removeEventListener('storage', onSetStorage)
        }
    }, [])

    if (!visible) return null;

    return (
        <FlexBox gx={8} align='center'>
            <IPhoneSwitcher active={active} setActive={onSetActive} />
            <Label>{t('lms.audio.copy_link_mode')}</Label>
        </FlexBox>
    )
}import {useCallback, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Colors, FlexBox} from "@brg/ui";
import styled from "styled-components";
import {IPhoneSwitcher} from "./IPhoneSwitcher";

const Label = styled.span`
  color: ${Colors.galBlack47};
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`

export const CopyLinkSwitcher = () => {
    const [active, setActive] = useState(
        localStorage.getItem('copyLinkMode') === 'true'
    )
    const [visible, setIsVisible] = useState(
        localStorage.getItem('copyLinkMode') === 'true'
    )
    const { t } = useTranslation()

    // @ts-ignore
    const onSetActive = useCallback((value) => {
        localStorage.setItem('copyLinkMode', value ? 'true' : 'false')
        setActive(value)
    }, [])

    useEffect(() => {
        const onSetStorage = (e: any) => {
            if (e.key === 'copyLinkMode') {
                setActive(e.newValue === 'true')
                if (e.newValue === 'true') setIsVisible(true)
            }
        }

        window.addEventListener('storage', onSetStorage)

        return () => {
            localStorage.setItem('copyLinkMode', 'false')
            window.removeEventListener('storage', onSetStorage)
        }
    }, [])

    if (!visible) return null;

    return (
        <FlexBox gx={8} align='center'>
            <IPhoneSwitcher active={active} setActive={onSetActive} />
            <Label>{t('lms.audio.copy_link_mode')}</Label>
        </FlexBox>
    )
}